// extracted by mini-css-extract-plugin
export default {"IconButton_0":"OverflowMenu-module__IconButton_0--P3118"};